import {Event} from '@duesyco/shared'
import {format, parseISO} from "date-fns";

export const formatDateTimeLocal = (date: Date | undefined): string => {
    if (!date) return ''
    const pad = (num: number) => String(num).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const MEDIUM_DATE_FORMAT = 'MMM d, yyyy'

export const timeOfDayGreeting = (date: Date = new Date()): string => {
    const hours = date.getHours()

    if (hours >= 12 && hours < 17) return 'Afternoon'
    if (hours >= 17) return 'Evening'

    return 'Morning'
}

export const greetingForUser = (firstName?: string | null, date: Date = new Date()): string => {
    const greeting = timeOfDayGreeting(date)

    return firstName ? `${greeting} ${firstName}!` : `${greeting}!`
}

export const formatLongDate = (date: Date = new Date()): string => {
    return format(date, 'MMMM d, yyyy')
}

export const formatMediumDate = (date: Date = new Date()): string => {
    return format(date, MEDIUM_DATE_FORMAT)
}

const ymd = (date: Date): string => {
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
}

export const formatShortDateTime = (value: string | Date): string => {
    const date = new Date(value)
    const pattern = date.getFullYear() === new Date().getFullYear()
        ? 'M/d h:mm a'
        : 'M/d/yy h:mm a'
    return format(date, pattern)
}

/**
 * Compact `starts_at`/`ends_at` range for space-constrained UI: `M/dd` when
 * both dates fall in the current calendar year, otherwise `M/dd/yy`.
 * Collapses to a single date when the range is one day (or `endsAt` is
 * absent) rather than repeating the same date twice.
 */
export const formatShortDateRange = (startsAt: string, endsAt: string | null): string => {
    const startDate = parseISO(startsAt)
    const endDate = endsAt ? parseISO(endsAt) : null
    const thisYear = new Date().getFullYear()
    const bothThisYear = startDate.getFullYear() === thisYear && (endDate === null || endDate.getFullYear() === thisYear)
    const pattern = bothThisYear ? 'M/dd' : 'M/dd/yy'

    if (endDate === null || ymd(startDate) === ymd(endDate)) {
        return format(startDate, pattern)
    }

    return `${format(startDate, pattern)} – ${format(endDate, pattern)}`
}

export const dateStringForEvent = (
    event: Event,
    dateFormat: string = MEDIUM_DATE_FORMAT
): string => {
    const startsAt = event.starts_at ? new Date(event.starts_at) : null
    const endsAt = event.ends_at ? new Date(event.ends_at) : null
    const sameDay = startsAt && endsAt && ymd(startsAt) === ymd(endsAt)

    if (sameDay) {
        return format(startsAt, dateFormat)
    }

    return startsAt && endsAt ? format(startsAt, dateFormat) + ' - ' + format(endsAt, dateFormat) : ''
}
